<template>
  <div class="channel-config">
    <!-- 渠道切换 -->
    <el-tabs v-model="activeGroup" @tab-click="handleTabChange" type="border-card">
      <el-tab-pane label="有赞配置" name="YOUZAN">
        <div class="tab-content">
          <el-form :model="youzanForm" :rules="youzanRules" ref="youzanFormRef" label-width="140px" label-position="right">
            <el-form-item label="API 域地址" prop="apiUrl">
              <el-input v-model="youzanForm.apiUrl" placeholder="https://open.youzanyun.com" clearable />
            </el-form-item>
            <el-form-item label="客户端ID" prop="clientId">
              <el-input v-model="youzanForm.clientId" placeholder="请输入有赞客户端ID" clearable />
            </el-form-item>
            <el-form-item label="客户端密钥" prop="clientSecret">
              <el-input v-model="youzanForm.clientSecret" placeholder="请输入有赞客户端密钥" show-password />
            </el-form-item>
            <el-form-item label="店铺ID" prop="shopId">
              <el-input v-model="youzanForm.shopId" placeholder="请输入有赞店铺ID" clearable />
            </el-form-item>
            <el-form-item label="创建会员开关">
              <div>
                <el-switch
                  v-model="youzanForm.createMemberEnabled"
                  active-text="开启"
                  inactive-text="关闭"
                  :active-value="'true'"
                  :inactive-value="'false'"
                />
                <div class="switch-hint">关闭时，新建会员将不调用有赞创建客户接口（仅打印日志）</div>
              </div>
            </el-form-item>
          </el-form>
          <div class="btn-row">
            <el-button type="primary" icon="el-icon-check" :loading="saving" @click="saveYouzan">保 存</el-button>
            <el-button v-if="canViewToken" icon="el-icon-view" :disabled="!youzanForm.shopId" :loading="tokenStatusLoading" @click="viewToken">查看Token</el-button>
            <el-button v-if="canRefreshToken" type="warning" icon="el-icon-refresh" :disabled="!youzanForm.shopId" :loading="tokenRefreshLoading" @click="refreshToken">强制刷新</el-button>
          </div>
        </div>
      </el-tab-pane>

      <el-tab-pane label="科脉配置" name="KEMAI">
        <div class="tab-content">
          <el-form :model="kemaiForm" :rules="kemaiRules" ref="kemaiFormRef" label-width="140px" label-position="right">
            <el-form-item label="API 基地址" prop="apiUrl">
              <el-input v-model="kemaiForm.apiUrl" placeholder="https://open.cs.kemai.com.cn" clearable />
            </el-form-item>
            <el-form-item label="应用Key" prop="openKey">
              <el-input v-model="kemaiForm.openKey" placeholder="请输入科脉应用Key" clearable />
            </el-form-item>
            <el-form-item label="应用密钥" prop="openSecret">
              <el-input v-model="kemaiForm.openSecret" placeholder="请输入科脉应用密钥" show-password />
            </el-form-item>
            <el-form-item label="商户ID" prop="shopAdminId">
              <el-input v-model="kemaiForm.shopAdminId" placeholder="请输入科脉商户ID" clearable />
            </el-form-item>
            <el-form-item label="创建会员店铺ID" prop="createStoreId">
              <el-input v-model="kemaiForm.createStoreId" placeholder="请输入创建会员时的店铺ID" clearable />
            </el-form-item>
            <el-form-item label="创建会员开关">
              <div>
                <el-switch
                  v-model="kemaiForm.createMemberEnabled"
                  active-text="开启"
                  inactive-text="关闭"
                  :active-value="'true'"
                  :inactive-value="'false'"
                />
                <div class="switch-hint">关闭时，新建会员将不调用科脉创建会员接口（仅打印日志）</div>
              </div>
            </el-form-item>

            <el-divider>交易流水配置（销售/收银流水同步）</el-divider>

            <el-form-item label="流水 API 基地址" prop="flowApiUrl">
              <el-input v-model="kemaiForm.flowApiUrl" placeholder="https://open-portal.cs.kemai.com.cn" clearable />
            </el-form-item>
            <el-form-item label="流水应用Key" prop="flowOpenKey">
              <el-input v-model="kemaiForm.flowOpenKey" placeholder="请输入科脉交易流水应用Key" clearable />
            </el-form-item>
            <el-form-item label="流水应用密钥" prop="flowOpenSecret">
              <el-input v-model="kemaiForm.flowOpenSecret" placeholder="请输入科脉交易流水应用密钥" show-password />
            </el-form-item>
            <el-form-item label="流水商户ID" prop="flowShopAdminId">
              <el-input v-model="kemaiForm.flowShopAdminId" placeholder="请输入科脉交易流水商户ID" clearable />
            </el-form-item>
          </el-form>
          <div class="btn-row">
            <el-button type="primary" icon="el-icon-check" :loading="saving" @click="saveKemai">保 存</el-button>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>

    <!-- 保存成功提示 -->
    <div v-if="showSuccess" class="success-tip">
      <i class="el-icon-circle-check"></i> 配置保存成功
    </div>

    <!-- Token 状态弹窗 -->
    <el-dialog title="有赞 Token 状态" :visible.sync="tokenStatusVisible" width="500px">
      <el-descriptions :column="1" border v-if="tokenStatusData">
        <el-descriptions-item label="店铺ID">{{ tokenStatusData.shopId }}</el-descriptions-item>
        <el-descriptions-item label="Access Token" style="word-break: break-all;">{{ tokenStatusData.accessToken || '-' }}</el-descriptions-item>
        <el-descriptions-item label="过期时间">{{ tokenStatusData.expireTime ? formatTimestamp(tokenStatusData.expireTime) : '-' }}</el-descriptions-item>
        <el-descriptions-item label="获取时间">{{ tokenStatusData.obtainTime ? formatTimestamp(tokenStatusData.obtainTime) : '-' }}</el-descriptions-item>
        <el-descriptions-item label="剩余有效期">
          <el-tag :type="tokenStatusData.expired ? 'danger' : 'success'" size="small">
            {{ tokenStatusData.expired ? '已过期' : tokenStatusData.remainingHours + ' 小时' }}
          </el-tag>
        </el-descriptions-item>
      </el-descriptions>
      <div v-else class="empty-tip">暂无 Token 缓存，请先保存配置后手动刷新获取</div>
      <div slot="footer">
        <el-button @click="tokenStatusVisible = false">关 闭</el-button>
        <el-button v-if="canRefreshToken" type="primary" @click="tokenStatusVisible = false; refreshToken()">强制刷新</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { sysConfigList, sysConfigBatchSave } from '@/api/sysConfig'
import request from '@/utils/request'
import { mapState } from 'vuex'

export default {
  name: 'ChannelConfig',
  data() {
    return {
      activeGroup: 'YOUZAN',
      saving: false,
      showSuccess: false,
      tokenStatusLoading: false,
      tokenRefreshLoading: false,
      tokenStatusVisible: false,
      tokenStatusData: null,
      // 有赞表单
      youzanForm: { apiUrl: '', clientId: '', clientSecret: '', shopId: '', createMemberEnabled: 'false' },
      // 科脉表单（会员+交易流水）
      kemaiForm: { apiUrl: '', openKey: '', openSecret: '', shopAdminId: '', createStoreId: undefined, createMemberEnabled: 'false', flowApiUrl: '', flowOpenKey: '', flowOpenSecret: '', flowShopAdminId: '' },
      // 校验规则
      youzanRules: {
        apiUrl: [{ required: true, message: '请输入API基址', trigger: 'blur' }]
      },
      kemaiRules: {
        apiUrl: [{ required: true, message: '请输入API基址', trigger: 'blur' }]
      }
    }
  },
  created() {
    this.loadConfig(this.activeGroup)
  },
  computed: {
    ...mapState('user', ['permissions']),
    canViewToken() {
      return (this.permissions || []).includes('channelConfig:viewToken')
    },
    canRefreshToken() {
      return (this.permissions || []).includes('channelConfig:refreshToken')
    }
  },
  methods: {
    handleTabChange(tab) {
      this.activeGroup = tab.name
      this.showSuccess = false
      this.loadConfig(tab.name)
    },

    loadConfig(group) {
      sysConfigList({ configGroup: group }).then(res => {
        const list = res.data || []
        const map = {}
        list.forEach(item => { map[item.configKey] = item.configValue })
        if (group === 'YOUZAN') this.youzanForm = { ...this.youzanForm, ...map }
        else if (group === 'KEMAI') {
          // 合并会员配置和交易流水配置到同一表单
          this.kemaiForm = { ...this.kemaiForm, ...map }
        }
      })
      // 科脉tab需额外加载交易流水配置
      if (group === 'KEMAI') {
        sysConfigList({ configGroup: 'KEMAI_FLOW' }).then(res => {
          const list = res.data || []
          const map = {}
          list.forEach(item => {
            const key = item.configKey === 'apiUrl' ? 'flowApiUrl' :
                        item.configKey === 'openKey' ? 'flowOpenKey' :
                        item.configKey === 'openSecret' ? 'flowOpenSecret' :
                        item.configKey === 'shopAdminId' ? 'flowShopAdminId' : item.configKey
            map[key] = item.configValue
          })
          this.kemaiForm = { ...this.kemaiForm, ...map }
        })
      }
    },

    saveYouzan() {
      this.$refs.youzanFormRef.validate(valid => {
        if (!valid) return
        this.doSave('YOUZAN', this.youzanForm)
      })
    },

    saveKemai() {
      this.$refs.kemaiFormRef.validate(valid => {
        if (!valid) return
        // 提交会员配置到 KEMAI 组
        const memberData = {
          apiUrl: this.kemaiForm.apiUrl,
          openKey: this.kemaiForm.openKey,
          openSecret: this.kemaiForm.openSecret,
          shopAdminId: this.kemaiForm.shopAdminId,
          createStoreId: this.kemaiForm.createStoreId,
          createMemberEnabled: this.kemaiForm.createMemberEnabled
        }
        // 提交交易流水配置到 KEMAI_FLOW 组
        const flowData = {
          apiUrl: this.kemaiForm.flowApiUrl,
          openKey: this.kemaiForm.flowOpenKey,
          openSecret: this.kemaiForm.flowOpenSecret,
          shopAdminId: this.kemaiForm.flowShopAdminId
        }
        this.saving = true
        this.showSuccess = false
        Promise.all([
          sysConfigBatchSave('KEMAI', null, memberData),
          sysConfigBatchSave('KEMAI_FLOW', null, flowData)
        ]).then(() => {
          this.saving = false
          this.showSuccess = true
          setTimeout(() => { this.showSuccess = false }, 3000)
        }).catch(() => {
          this.saving = false
        })
      })
    },

    doSave(group, form) {
      this.saving = true
      this.showSuccess = false
      sysConfigBatchSave(group, null, form).then(() => {
        this.saving = false
        this.showSuccess = true
        setTimeout(() => { this.showSuccess = false }, 3000)
      }).catch(() => {
        this.saving = false
      })
    },

    viewToken() {
      if (!this.youzanForm.shopId) {
        this.$message.warning('请先填写店铺ID')
        return
      }
      this.tokenStatusLoading = true
      this.tokenStatusVisible = true
      this.tokenStatusData = null
      request({
        url: `/api/youzan/token/status/${this.youzanForm.shopId}`,
        method: 'get'
      }).then(res => {
        this.tokenStatusData = res.data || {}
      }).catch(err => {
        this.$message.error(err.message || '获取Token状态失败')
        this.tokenStatusVisible = false
      }).finally(() => {
        this.tokenStatusLoading = false
      })
    },

    refreshToken() {
      if (!this.youzanForm.shopId) {
        this.$message.warning('请先填写店铺ID')
        return
      }
      this.$confirm('确认强制刷新有赞Token？刷新后旧Token将立即失效', '提示', {
        confirmButtonText: '确认刷新',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.tokenRefreshLoading = true
        request({
          url: `/api/youzan/token/refresh/${this.youzanForm.shopId}`,
          method: 'post'
        }).then(() => {
          this.$message.success('Token刷新成功')
        }).catch(err => {
          this.$message.error(err.message || '刷新失败')
        }).finally(() => {
          this.tokenRefreshLoading = false
        })
      }).catch(() => {})
    },

    formatTimestamp(sec) {
      if (!sec) return '-'
      const d = new Date(sec * 1000)
      return d.getFullYear() + '-' +
        String(d.getMonth() + 1).padStart(2, '0') + '-' +
        String(d.getDate()).padStart(2, '0') + ' ' +
        String(d.getHours()).padStart(2, '0') + ':' +
        String(d.getMinutes()).padStart(2, '0') + ':' +
        String(d.getSeconds()).padStart(2, '0')
    }
  }
}
</script>

<style lang="less" scoped>
.channel-config {
  padding: 20px;
}
.tab-content {
  max-width: 800px;
  margin-top: 20px;
  background: #fff;
  border-radius: 8px;
  padding: 30px;
  box-shadow: 0 1px 4px rgba(0,0,0,0.04);
}
.btn-row {
  text-align: center;
  margin-top: 24px;
}
.success-tip {
  position: fixed;
  top: 80px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 2000;
  background: #67c23a;
  color: #fff;
  padding: 10px 24px;
  border-radius: 6px;
  font-size: 14px;
  animation: fadeInOut 3s ease forwards;
  pointer-events: none;
}
@keyframes fadeInOut {
  0% { opacity: 0; transform: translate(-50%, -20px); }
  15%, 85% { opacity: 1; transform: translate(-50%, 0); }
  100% { opacity: 0; transform: translate(-50%, 20px); }
}
.switch-hint {
  margin-top: 4px;
  font-size: 12px;
  color: #909399;
}
.empty-tip {
  text-align: center;
  color: #909399;
  padding: 40px 0;
}
</style>
